module.exports = __webpack_public_path__ + "img/face-anguished.4a4eb91c.svg";